export default __webpack_public_path__ + "static/media/fedex.14c5bb62.png";